import { t } from "i18next";
import { z } from "zod";

import { dayjs } from "@thalamos/common";

import {
  FieldBuilder,
  MultiPageFormBuilder,
} from "../../../formBuilder/index.js";
import { dateTimeSchema, longTextSchema } from "../../../types/index.js";
import { tk } from "../../../types/Translation.js";
import { hasRemainedAtPlaceOfSafetySchema } from "./helpers.js";

export const formSpecification = new MultiPageFormBuilder()
  .withFieldNeverVisible({
    fieldName: "source",
    defaultValue: () => {
      return { value: "mhf" as const };
    },
    ...new FieldBuilder()
      .withNullableSchema(z.enum(["emha" as const, "mhf" as const]))
      .build(),
  })
  .withFieldAlwaysVisible({
    fieldName: "hasRemainedAtPlaceOfSafety",
    type: "radio",
    ...new FieldBuilder()
      .withSchema(hasRemainedAtPlaceOfSafetySchema)
      .captureValueLabel()
      .build(),
    label: tk("recordPolicePresence.whatWillYouDo"),
    requiredLabel: tk("recordPolicePresence.whatWillYouDoRequired"),
    options: [
      {
        label: tk("recordPolicePresence.stayedAgreeWithNhs"),
        value: "yes-stayed-agree-with-nhs",
      },
      {
        label: tk("recordPolicePresence.stayedDisagreeWithNhs"),
        value: "yes-stayed-disagree-with-nhs",
      },
      {
        label: tk("recordPolicePresence.escalatedAndLeft"),
        value: "no-escalated-and-left",
      },
    ],
  })
  .withFieldAlwaysVisible({
    fieldName: "reasoning",
    type: "textbox",
    ...new FieldBuilder().withNullableSchema(longTextSchema).build(),
    label: tk("recordPolicePresence.reasoning"),
    rows: "5",
    multiline: true,
  })
  .withFieldNeverVisible({
    fieldName: "createdAt",
    ...new FieldBuilder().withNullableSchema(dateTimeSchema).build(),
    defaultValue: () => ({ value: dayjs.utc().toISOString() }),
  })
  .withFieldNeverVisible({
    fieldName: "officerName",
    ...new FieldBuilder().withNullableSchema(longTextSchema).build(),
    defaultValue: () => null,
  })
  .withPage(["hasRemainedAtPlaceOfSafety", "reasoning"])
  .build({ t });

export type RecordPolicePresenceFormData = ReturnType<
  typeof formSpecification
>["formType"];
